__turbopack_context__.v({
  "backLink": "Docs-module__-294iq__backLink",
  "docsContainer": "Docs-module__-294iq__docsContainer",
  "docsList": "Docs-module__-294iq__docsList",
  "fadeIn": "Docs-module__-294iq__fadeIn",
  "imageCaption": "Docs-module__-294iq__imageCaption",
  "imageContainer": "Docs-module__-294iq__imageContainer",
  "noteBox": "Docs-module__-294iq__noteBox",
  "stepContainer": "Docs-module__-294iq__stepContainer",
  "stepContent": "Docs-module__-294iq__stepContent",
  "stepNumber": "Docs-module__-294iq__stepNumber",
  "stepTitle": "Docs-module__-294iq__stepTitle",
  "warningBox": "Docs-module__-294iq__warningBox",
});
